module.exports = __webpack_public_path__ + "static/media/pocket-change-home-tiny.4f9f3389.jpg";